/**
 * Created by skz on 2017/10/10 14:03
 */

// ===================================
// =========== 停车场帮助 =============
// ===================================

import request from '../ajax';

/**
 * 获取停车场帮助数据
 */
export function fetchHelpData() {
    return request.post({
        // url:'http://192.168.239.53:7300/mock/5a01d015cec0b05d316ddf12/utopa/app.do/utopa/service/fetchHelpData'
        'reqMethod': 'parking.userhelp.getHelpInfo'
    })
}

/**
 * 获取门禁帮助数据
 */
export function getTips() {
    return request.post({
        // url:'http://192.168.239.53:7300/mock/5a01d015cec0b05d316ddf12/utopa/app.do/utopa/service/fetchHelpData'
        'reqMethod': 'guard.content.getTips',
        params: {
          sysId: 1
        }
    })
}

/**
 * 获取积分规则
 */
export function getPointUseRule() {
    return request.post({
        // url:'http://192.168.239.53:7300/mock/5a01d015cec0b05d316ddf12/utopa/app.do/utopa/service/fetchHelpData'
        'reqMethod': 'base.app.pointInstance.getPointUseRule',
        params: {
            systemId: 1
        }
    })
}

/**
 * 获取签到规则
 */
export function getSignRule() {
    return request.post({
        // url:'http://192.168.239.53:7300/mock/5a01d015cec0b05d316ddf12/utopa/app.do/utopa/service/fetchHelpData'
        'reqMethod': 'utopa.sign.getSignRule',
        params: {
            systemId: 1
        }
    })
}

/**
 * 月保信息查询
 */
export function getSupportParkingLot() {
  return request.post({
      // url:'http://192.168.239.53:7300/mock/5a01d015cec0b05d316ddf12/utopa/app.do/utopa/service/fetchHelpData'
      'reqMethod': 'parking.yuebao.getSupportParkingLot'
  })
}
